import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { UserType } from '../api/ApiTypes';

export const Forbidden = () => {
    const { me } = useAuth();

    // Get readable role name
    const getUserRole = (userType: UserType | undefined) => {
        if (userType === undefined) return 'Unknown';

        switch (userType) {
            case UserType.CLIENT:
                return 'Client';
            case UserType.APPRAISER:
                return 'Appraiser';
            case UserType.STAFF:
                return 'Staff';
            case UserType.SYSTEM:
                return 'System';
            case UserType.REGISTERED:
                return 'Registered User';
            case UserType.SECRET:
                return 'Secret';
            default:
                return 'Unknown';
        }
    };

    return (
        <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 p-4">
            <div className="bg-white p-8 rounded-lg shadow-md max-w-md w-full text-center">
                <h1 className="text-2xl font-bold text-red-600 mb-4">Access Denied</h1>

                <p className="mb-6 text-gray-700">
                    You don't have permission to access this page.
                    {me && (
                        <>
                            <br />
                            Your current role: <span className="font-semibold">{getUserRole(me.userType)}</span>
                        </>
                    )}
                </p>

                <div className="flex flex-col space-y-2">
                    <Link
                        to="/dashboard"
                        className="bg-blue-600 text-white py-2 px-4 rounded hover:bg-blue-700 transition duration-200"
                    >
                        Go to Dashboard
                    </Link>
                </div>
            </div>
        </div>
    );
};